import React from 'react';
import { Skeleton, XStack, YStack } from '@usepepper/sprout-kit-ui';
import { useIsMobileBottomNavLayout } from '@/experiences/sales-portal/blocs/hooks/use-is-mobile-bottom-nav-layout';
import { useTheme } from '@/contexts/theme-context';

const AVATAR_SIZE = 40;
const PILL_HEIGHT = 24;
const SM_BAR_HEIGHT = 14;
const SM_LINE_HEIGHT = 21;
const XS_BAR_HEIGHT = 12;
const XS_LINE_HEIGHT = 18;

export const AlertCardSkeleton: React.FC = () => {
  const theme = useTheme();
  const isPhone = useIsMobileBottomNavLayout();

  return (
    <YStack
      accessibilityState={{ busy: true }}
      backgroundColor="$bgPrimaryDefault"
      gap="$8"
      padding="$16"
    >
      <Skeleton
        borderRadius={theme.sk.radii.radiusRound}
        height={PILL_HEIGHT}
        marginBottom="$4"
        variant="rect"
        width={isPhone ? 80 : 110}
      />
      <XStack alignItems="center" gap="$12" width="100%">
        <Skeleton height={AVATAR_SIZE} variant="circle" width={AVATAR_SIZE} />
        <YStack flex={1}>
          <YStack height={SM_LINE_HEIGHT} justifyContent="center">
            <Skeleton
              borderRadius={theme.sk.radii.radiusSmall}
              height={SM_BAR_HEIGHT}
              variant="rect"
              width={isPhone ? '45%' : 180}
            />
          </YStack>
          <YStack height={XS_LINE_HEIGHT} justifyContent="center">
            <Skeleton
              borderRadius={theme.sk.radii.radiusSmall}
              height={XS_BAR_HEIGHT}
              variant="rect"
              width={isPhone ? '85%' : 320}
            />
          </YStack>
        </YStack>
      </XStack>
      <YStack height={SM_LINE_HEIGHT} justifyContent="center">
        <Skeleton
          borderRadius={theme.sk.radii.radiusSmall}
          height={SM_BAR_HEIGHT}
          variant="rect"
          width={isPhone ? '79%' : 340}
        />
      </YStack>
    </YStack>
  );
};
